export default {
  none: 0,
  sm: "2px",
  default: "4px",
  md: "6px",
  lg: "8px",
  pill: "30px",
  full: "9999px",
};
